<template>
	<page style="background: #fff;">
		<c-form ref="form">
			<c-form-item label="销售客户" required>
				<c-select name="customer_id" async @search="searchCustomer"></c-select>
			</c-form-item>
			<c-form-item ref="items" label="销售明细" name="items" required>
				<template #handle>
					<span style="font-size: .26rem; color: #aaa;"><span style="color: var(--color-main)">{{productList.length}}</span>条记录</span>
				</template>
				<insert-data scan-name="扫码" @scan="scanHandle"></insert-data>
				<detail-card v-for="(item, i) in productList" :key="i" :index="i + 1" remove-button @remove="productList.splice(i, 1)">
					<template #title>
						<span>{{[item.brand_name, item.model_name, item.color_name, item.memory_name].filter(item => item).join(' ')}}</span>
					</template>

					<template #default>
						<c-field label="背贴码">{{item.produce_unique_code}}</c-field>
						<c-field label="成本价">￥{{item.cost_price || '-'}}</c-field>
					</template>

					<template #form>
						<detail-card-form label="售出金额" required>
							<c-input v-model="item.sale_price" name="sale_price" type="number" decimal="2" append-text="元"></c-input>
						</detail-card-form>
						<detail-card-form label="是否拆机" required>
							<div class="flex" style="gap: .32rem;">
								<c-switch v-model="item.sell_type" :state-text="['是', '否']" :state-value="[2, 1]"></c-switch>
								<c-select v-show="item.sell_type == 2" v-model="item.dismantle_items" class="flex-grow" name="dismantle_items" :multiple="{linefeed: false}" :options="DISMANTLE_ITEM" placeholder="请选择拆机项" style="width: auto;"></c-select>
							</div>
						</detail-card-form>
					</template>
				</detail-card>
			</c-form-item>
		</c-form>

		<template #button>
			<div class="foot flex-between-center">
				<div class="foot-total flex-center">
					<label>合计：</label>
					<b>￥{{totalSum}}</b>
				</div>
				<c-button class="foot-button" size="form" color="main" @click="submitHandle">确认提交</c-button>
			</div>
		</template>
	</page>
</template>

<script>
	import {asyncMapState} from '@/store'

	export default {
		data() {
			return {
				productList: [],
				currentPay: 1
			}
		},

		computed: {
			...asyncMapState(['DISMANTLE_ITEM']),

			totalSum() {
				let sum = 0;
				this.productList.forEach(item => {
					sum += parseFloat(item.sale_price) || 0;
				});
				return parseFloat(sum.toFixed(2));
			}
		},
		
		methods: {
			searchCustomer(keyword, resolve) {
				this.request({
					url: '/sale/customer/options',
					data: {
						keyword
					},
					success: data => {
						resolve(data.map(item => {
							return {
								name: item.customer_name,
								value: item.id
							};
						}));
					}
				});
			},

			scanHandle(code) {
				if (this.productList.some(item => item.produce_unique_code == code)) {
					this.$message({
						message: '该背贴码已存在'
					});
					return;
				}
				this.request({
					url: '/productCode/queryByCode',
					data: {
						produce_unique_code: code,
						query_type: 'sale'
					},
					success: data => {
						//售出金额默认取小黑靓机渠道售价，该商品无渠道定价时为空由开单人自行填写
						data.sale_price = data.channel_sale_price || '';
						this.productList.push(data);
					}
				});
			},

			submitHandle() {
				this.$refs.form.submit({
					url: '/offline/sale/order/create',
					rule: {
						customer_id: '请选择销售客户',
						items: [{
							type: 'function',
							message: '请扫描销售商品',
							fun: () => {
								return this.productList.length;
							}
						}, {
							type: 'function',
							message: '请完善商品金额',
							fun: () => {
								return !this.productList.some(item => !item.sale_price);
							}
						}]
					},
					dataFormatter: data => {
						return Object.assign(data, {
							products: JSON.stringify(this.productList.map(item => {
								return {
									produce_code: item.produce_unique_code,
									sale_price: parseFloat(item.sale_price),
									sell_type: item.sell_type || 1,
									dismantle_items: item.sell_type == 2 ? JSON.stringify(item.dismantle_items) : undefined
								}
							}))
						})
					},
					success: (data, res) => {
						this.globalDialog('offlineOrderPay', {
							props: {
								orderId: res.orders.map(item => item.order_id)
							}
						}, () => {
							this.$message({
								message: '操作成功',
								mask: true
							});
							this.mp.navigateBack(true);
						}, () => {
							this.mp.navigateBack();
						});
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.foot {
		width: 100%;

		&-total {
			font-size: .28rem;
			color: #666;

			b {
				font-size: .32rem;
				font-weight: 600;
				color: #f00;
			}
		}

		&-button {
			max-width: 2.6rem;
		}
	}
</style>